<ul>
  <li class="px-3" *appHasPermission="'client:read'">
    <a
      class="size-12 flex items-center justify-center rounded-lg text-zinc-500 hover:text-zinc-400 [.active]:bg-zinc-800 [.active]:text-zinc-300 transition-colors"
      routerLink="clients"
      routerLinkActive="active"
      matTooltip="Cliënten"
      matTooltipPosition="after"
    >
      <mat-icon>person</mat-icon>
    </a>
  </li>
  <li class="px-3" *appHasPermission="'device:read'">
    <a
      class="size-12 flex items-center justify-center rounded-lg text-zinc-500 hover:text-zinc-400 [.active]:bg-zinc-800 [.active]:text-zinc-300 transition-colors"
      routerLink="devices"
      routerLinkActive="active"
      matTooltip="Apparaten"
      matTooltipPosition="after"
    >
      <mat-icon>memory</mat-icon>
    </a>
  </li>
  <li class="px-3" *appHasPermission="'interaction:read'">
    <a
      class="size-12 flex items-center justify-center rounded-lg text-zinc-500 hover:text-zinc-400 [.active]:bg-zinc-800 [.active]:text-zinc-300 transition-colors"
      routerLink="templates"
      routerLinkActive="active"
      matTooltip="Templates"
      matTooltipPosition="after"
    >
      <mat-icon>article</mat-icon>
    </a>
  </li>
  <li class="px-3" *appHasPermission="'media:read'">
    <a
      class="size-12 flex items-center justify-center rounded-lg text-zinc-500 hover:text-zinc-400 [.active]:bg-zinc-800 [.active]:text-zinc-300 transition-colors"
      routerLink="media"
      routerLinkActive="active"
      matTooltip="Algemene media"
      matTooltipPosition="after"
    >
      <mat-icon>subscriptions</mat-icon>
    </a>
  </li>
</ul>

<div class="mt-auto">
  <mat-divider
    class="mx-4! my-2! rounded-full [--mat-divider-color:var(--color-zinc-800)]"
  />

  <ul>
    <li class="px-3">
      <a
        *appHasPermission="settingsPermissions"
        class="size-12 flex items-center justify-center rounded-lg text-zinc-500 hover:text-zinc-400 [.active]:bg-zinc-800 [.active]:text-zinc-300 transition-colors"
        routerLink="settings"
        routerLinkActive="active"
        matTooltip="Instellingen"
        matTooltipPosition="after"
      >
        <mat-icon>settings</mat-icon>
      </a>
    </li>

    <li class="px-3">
      <a
        *appHasPermission="'download:read'"
        class="size-12 flex items-center justify-center rounded-lg text-zinc-500 hover:text-zinc-400 [.active]:bg-zinc-800 [.active]:text-zinc-300 transition-colors"
        routerLink="downloads"
        routerLinkActive="active"
        matTooltip="Downloads"
        matTooltipPosition="after"
      >
        <mat-icon>download</mat-icon>
      </a>
    </li>

    <mat-divider
      class="mx-4! my-2! rounded-full [--mat-divider-color:var(--color-zinc-800)]"
    />

    <li class="px-3">
      <a
        class="size-12 flex items-center justify-center rounded-lg text-zinc-500 hover:text-zinc-400 [.active]:bg-zinc-800 [.active]:text-zinc-300 transition-colors"
        routerLink="docs"
        routerLinkActive="active"
        target="_blank"
        matTooltip="Handleiding"
        matTooltipPosition="after"
      >
        <mat-icon>book_4</mat-icon>
      </a>
    </li>

    <li class="px-3">
      <a
        class="size-12 flex items-center justify-center rounded-lg text-zinc-500 hover:text-zinc-400"
        href="https://docs.google.com/forms/d/e/1FAIpQLSe9o-ekhcXrr0927CTJnkVDqIqFKlIB0FY97zXSDMCC41ONQQ/viewform"
        target="_blank"
        matTooltip="Support"
        matTooltipPosition="after"
      >
        <mat-icon>help</mat-icon>
      </a>
    </li>
  </ul>
</div>
